import { useEffect, useMemo, useState } from 'react';

export const PAGE_SIZE_OPTIONS = [5, 10, 20, 30, 50, 100];

/** Client-side pagination for a list of rows. */
export function usePagination<T>(rows: T[], initialPageSize = 10) {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSizeState] = useState(initialPageSize);

  const totalPages = Math.max(1, Math.ceil(rows.length / pageSize));

  // Stay on a valid page when rows shrink (delete, filter change).
  useEffect(() => {
    if (page > totalPages) setPage(totalPages);
  }, [page, totalPages]);

  const pageRows = useMemo(() => {
    const start = (page - 1) * pageSize;
    return rows.slice(start, start + pageSize);
  }, [rows, page, pageSize]);

  const setPageSize = (size: number) => {
    setPageSizeState(size);
    setPage(1);
  };

  return { page, setPage, pageSize, setPageSize, totalPages, pageRows };
}
